import React, {useState, useEffect} from 'react'

import axios from 'axios';
import { SituationList } from './SituationList';
import PreviewIcon from '@mui/icons-material/Preview';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AssessmentIcon from '@mui/icons-material/Assessment';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

const model = {
  modulename: "Behaviour Editor"
};

const AssessmentEditor = (props) => {

  /* data handling */
  const data = props.data.data;
  const [Id, setId] = useState(data.Id);
  const [Strength, setStrength] = useState('');

  const [review, setReview] = useState((data.TotalSituationsAnswered > 0 && data.TotalSituationsAnswered == data.TotalSituations));

  const [pageData, setPageData] = useState({
    status: "",
    data: [],
    total: 0
  });

const [pageState, setPageState] = useState({ loading: false});
const [errors, setErrors] = useState("");

  useEffect(()=>{
    if(pageState.loading == false){
      axios.get('/userassessments/analyseassessment?id=' + Id)
        .then(function (response) {
          if(response.data.status == "success"){
            setErrors("");
            setPageData(response.data);
            setStrength(response.data.data.Strength);
            setPageState({loading: true});
          }
          else{
            setErrors(response.data.message);
          }
        })
        .catch(function (error) {
          setErrors(error.message);
        });
    }
  }); 

  const showList=()=>{
    props.setEditorState({open: false, data : null});
    props.setPageState({ loading: false});
  }

  const generatePDF=()=>{
    axios.get('/pdf/regeneratereportfile?id=' + Id)
    .then(function (response) {
      if(response.data.status == "success"){
        setErrors("");
        alert('PDF report re-generated');
      }
      else{
        setErrors(response.data.message);
      }
    })
    .catch(function (error) {
      setErrors(error.message);
    });
  }


  const handleSubmitClick =(e)=>{
    e.preventDefault();

    var data = {
      Id: Id,
      Strength: Strength
    };

    props.setErrors("");

    axios.post('/userassessments/updatenote',data )
    .then(function (response) {
      if(response.data.status == "success"){
         alert("Note updated...");
      }
    })
    .catch(function (error) {
      
    });
  };

  return (
    <div>
        <form className="form form-md">
          <div className="row">
            <div className={review ? "col-4" : "col-7"}>
            <h4>{data.FullName}</h4>
            </div>
            <div className="col">
            <a href="javascript:void(0);" className="btn btn-outline-primary" onClick={showList}><ArrowBackIosNewIcon/> Back to Assessments</a>&nbsp;
            <a className="btn btn-outline-primary" href={'/assessment?token=' + Id} target="_blank"><AssessmentIcon/> Assessment</a>&nbsp;
            { review ?  <a className="btn btn-outline-primary" href={axios.defaults.baseURL + '/pdf/charts?id=' + Id} target="_blank"><PreviewIcon/> Assessment Review & Report</a> : ""}
            {/* <a className="btn btn-outline-primary" href="javascript:void(0);" onClick={generatePDF}><PictureAsPdfIcon/> Update PDF Report</a> */}
            </div>
          </div>
          <div>
          <Tabs>
            <TabList>
              <Tab>Assessment</Tab>
              <Tab>Special Notes</Tab>
            </TabList>
            <TabPanel>
            { pageState.loading == true ? <SituationList rows={pageData.data.UserAnswers} behaviors={pageData.data.Behaviors} /> : <div>Please wait...</div> }
            </TabPanel>
            <TabPanel>
              <h3>Top 3 Strengths</h3>
              <textarea className="form-control" rows={10} onChange={e=> setStrength(e.target.value)} value={Strength}></textarea>
              <div className="btns">
              <button type="button" className="btn btn-primary mt-3" onClick={handleSubmitClick} >Save</button>&nbsp;
            </div>
          </TabPanel>
          </Tabs>
          
          </div>
        </form>
      </div>
  )
}

export default AssessmentEditor

